import React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';

import { Button, Form, Field, Row, FileInput, MaskedInput, RelationSelect } from '@smartplatform/ui';
import { Editor } from '../../components';
import Convocations from './Convocations';
import UserPopup from './UserPopup';
import AppointmentDates from './appointment-dates';
import store from '../../store';
import { userName } from '../../../site/pages/profile/tools';
import './style.scss';

@observer
export default class Edit extends React.Component {

	@observable record = null;
	@observable linkedUser = null;
	@observable error = null;
	@observable saveError = null;
	@observable userPopup = false;

	constructor(props) {
		super(props);
		this.init();
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.match.params.id !== this.props.match.params.id) {
			this.init();
		}
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		this.convocations = await store.model.DeputyConvocation.find({
			where: {
				deputyId: this.id,
			}
		});
		if (this.id) {
			try {
				this.record = await store.model.Deputy.findById(this.id, {
					include: ['fraction', 'division', 'divisionGroup', 'user']
				});
				this.linkedUser = this.record.user;
			}
			catch(e) {
				this.error = e.message;
			}
		}
		else {
			this.record = new store.model.Deputy();
		}
	};

	onDivisionChange = value => {
		console.log('onDivisionChange', value);
		if (value) this.record.divisionGroup = null;
	};

	onDivisionGroupChange = value => {
		console.log('onDivisionGroupChange', value);
		if (value) this.record.division = null;
	};

	@action onSave = async deputy => {
		this.saveError = null;
		try {
			if (this.linkedUser && this.linkedUser.id !== deputy.userId) {
				this.linkedUser.deputyId = null;
				await this.linkedUser.save();
			}
			this.linkedUser = deputy.user;
			if (deputy.user) {
				deputy.user.deputyId = deputy.id;
				await deputy.user.save();
			}
			if (!this.id) {
				this.props.history.push(`/admin/deputies/${deputy.id}`);
			}
		}
		catch (e) {
			this.saveError = 'Ошибка сохранения!';
		}
	};

	// userName = user => <>{userName(user)} ({user.email})</>;

	userName = user => !user.deputyId || (user.deputyId && user.deputyId === this.record.id) ?
		<>{userName(user)} ({user.email})</>
		:
		<div onClick={this.preventUser} className="not-available">{userName(user)} (занято)</div>;

	preventUser = e => {
		e.stopPropagation();
	};

	showUserPopup = () => this.userPopup = true;

	closeUserPopup = async updated => {
		if (updated) await this.init();
		this.userPopup = false;
	};

	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;
		
		const controls = this.saveError ? <div className="save-error">{this.saveError}</div> : null;
		
		return <>
			{this.id ? <p>Депутат: {this.record.lastName} {this.record.firstName} {this.record.middleName}</p> : <p>Депутат</p>}
			<br />
			<Form record={this.record} onSave={this.onSave} stay={true} rootPath="/admin" returnTo="/admin/deputies" className="deputy-edit" controls={controls}>
				<Row>
					<Field property="lastName" label="Фамилия" />
					<Field property="firstName" label="Имя" />
					<Field property="middleName" label="Отчество" />
				</Row>
{/*
				<Row>
					<Field relation="fraction" property="shortName" label="Фракция"><RelationSelect filter={{ where: { existing: true }}} /></Field>
					<Field relation="division" property="name" label="Избирательный округ">
						<RelationSelect onChange={this.onDivisionChange}/>
					</Field>
					<Field relation="divisionGroup" property="name" label="Регинальная группа">
						<RelationSelect onChange={this.onDivisionGroupChange}/>
					</Field>
				</Row>
*/}
				<Row>
					<Field label="Привязанный аккаунт" relation="user" computed={this.userName}>
						<RelationSelect />
					</Field>
					<div className="form-field">
						<label>Действия</label>
						<Button onClick={this.showUserPopup}>{this.record.userId ? 'Редактировать аккаунт' : 'Создать аккаунт'}</Button>
					</div>
					<Field className='isDeputyDie' property='isDead' label='Депутат мертв?'/>
					{/*<div>{this.user ? `${this.user.id}: ${userName(this.user)}` : '-'}</div>*/}
					{/*<div>{this.record.user ? `${this.record.user.id}: ${userName(this.record.user)}` : '-'}</div>*/}
				</Row>
				<Row>
					<Field label="Телефон" property="phone"><MaskedInput mask="+7 999 999 9999" /></Field>
					<div/>
					<div/>
				</Row>
				<div className="row">
					<div className="col-lg-2 col-md-2 col-sm-2 col-2">
						<Field label="Личный прием" property="appointment" />
					</div>
					<div className="col-lg-10 col-md-10 col-sm-10 col-10">
						<Field label="Даты личного приёма" property="appointmentDates">
							<AppointmentDates />
						</Field>
					</div>
				</div>
				<Row>
					<div style={{ marginBottom: 15 }}>
						<Field property="photo" label="Фото"><FileInput /></Field>
						{this.record.photo && <img src={this.record.downloadFile('photo')} width={200} height={300} style={{ objectFit: 'content' }} />}
					</div>
					<div />
					<div />
				</Row>
				<div className="form-field">
					<label>Созывы</label>
					{this.record.id ? <Convocations deputy={this.record} /> : 'Сначала сохраните запись'}
				</div>
				<Field className='end-date-link' property='endDateLink' label='Ссылка на постановление Государственного Собрания (Ил Тумэн) о досрочном сложении полномочий' disabled={!this.convocations.filter((conv) => conv.endDate)[0]}/>
				<Field className="quill-field" property="description" label="Описание">
					<Editor height={250} />
				</Field>
				<Field className="quill-field" property="bio" label="Биография">
					<Editor height={400} />
				</Field>
				<Field className="quill-field" property="contact" label="Контактная информация">
					<Editor height={250} />
				</Field>
				<Field className="quill-field" property="laws" label="Законы инициированные депутатом">
					<Editor height={250} />
				</Field>
				<Field className="quill-field" property="prevConvocationInfo" label="Информация о предыдущих созывах">
					<Editor height={250} />
				</Field>
			</Form>
			{this.userPopup && <UserPopup deputy={this.record} userId={this.record.userId} onClose={this.closeUserPopup} />}
		</>;
	}

}
